export default scrollTo => {
    if ($('a[data-scroll-to]').length < 1) {
        return false;
    }

    let scrollToLink = $('a[data-scroll-to]');

    $(scrollToLink).on('click', event => {
        let hash      = $(event.currentTarget).attr('href');
        let offsetTop = $(`[data-scroll="${hash}"]`).offset().top;

        $('html, body').animate({
            scrollTop: offsetTop
        }, 750, () => {
            window.location.hash = hash;
        });
    });
};
